import { f as v } from "./function-uncurry-this-clause-99074d1c.js";
import { P as T, y as p, b as C, f as S, G as b, C as y, Z as d, d as I } from "./export-cdcbfb2b.js";
import { c as o, t as s } from "./classof-21a3574e.js";
var e = v, $ = T, g = p, R = e(e.bind), L = function(r, t) {
  return $(r), t === void 0 ? r : g ? R(r, t) : function() {
    return r.apply(t, arguments);
  };
}, _ = C, G = S, c = y, O = o, h = b, B = d, i = function() {
}, u = h("Reflect", "construct"), a = /^\s*(?:class|function)\b/, N = _(a.exec), m = !a.test(i), n = function(t) {
  if (!c(t))
    return !1;
  try {
    return u(i, [], t), !0;
  } catch {
    return !1;
  }
}, f = function(t) {
  if (!c(t))
    return !1;
  switch (O(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return m || !!N(a, B(t));
  } catch {
    return !0;
  }
};
f.sham = !0;
var M = !u || G(function() {
  var r;
  return n(n.call) || !n(Object) || !n(function() {
    r = !0;
  }) || r;
}) ? f : n, x = s, A = o, P = x ? {}.toString : function() {
  return "[object " + A(this) + "]";
}, j = s, U = I, E = P;
j || U(Object.prototype, "toString", E, { unsafe: !0 });
export {
  L as f,
  M as i
};
